import {createAsyncThunk} from '@reduxjs/toolkit';
import fetchCampaigns from './fetchCampaigns';
import fetchCampaignsAnalytics from './fetchCampaignsAnalytics';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

const loadCampaignsLibraryData = createAsyncThunk(
  `${BreadcrumbName.CampaignsLibrary}/loadCampaignsLibraryData`,
  async (_, {dispatch}) => {
    dispatch(fetchCampaigns()).then(() => dispatch(fetchCampaignsAnalytics()));
  },
);

export default loadCampaignsLibraryData;
